import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const REQUESTED_ITEMS_REQUESTED_ITEM_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/requested-items',
        iconClass: 'fas fa-file-alt',
        name: '::Menu:RequestedItems',
        layout: eLayoutType.application,
        requiredPolicy: 'ReturnLy.RequestedItems.RequestedClaims',
        order: 3
      },
      {
        path: '/requested-items/submit-claim',
        iconClass: 'fas fa-file-alt',
        name: 'SubmitClaim',
        invisible:true,
        requiredPolicy: 'ReturnLy.RequestedItems.CustomerClaimsCreate',
      },
      {
        path: '/requested-items/submit-whatsapp-claim',
        iconClass: 'fas fa-file-alt',
        name: 'SubmitWhatsAppClaim',
        invisible:true,
        requiredPolicy: 'ReturnLy.RequestedItems.CustomerClaimsCreate',
      },
    ]);

  };
}
